import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22 6v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1",
      style: {"fill":"none","stroke-width":"1.23px"},
      transform: "rotate(45 20.314 -1.244)scale(1.4)"
    }, null, -1),
    _createElementVNode("g", { transform: "matrix(.71428 0 0 .71428 3.671 3.429)" }, [
      _createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "1",
        style: {"fill":"none"}
      }),
      _createElementVNode("path", {
        d: "M18.944 12.33a1 1 0 0 0 0-.66A7.51 7.51 0 0 0 12 7.004a7.51 7.51 0 0 0-6.944 4.666 1 1 0 0 0 0 .66A7.51 7.51 0 0 0 12 16.996a7.51 7.51 0 0 0 6.944-4.666",
        style: {"fill":"none","fill-rule":"nonzero"}
      })
    ], -1)
  ]))]))
}
export default { render: render }